export default __webpack_public_path__ + "static/contact-d9fb2ac44ab299e3146bc687341c49ca.png";